import React, { useEffect, useState } from "react";
import PageMainBanner from '../../comps/PageMainBanner'
import Footer from '../../comps/Footer'
import Header from '../../comps/Header'
import { API_BASE_URL, IMG_BASE_URL } from "../../config/Base_Url_Config";
import { get_main_banner_section } from "../../api/Global";
import { user_Profile } from "../../api/Auth";


const ContactUs = () => {
      const [loading, setLoading] = useState(false);
      const [responseMessage, setResponseMessage] = useState("");
      const [get_banner_list, set_Banner_List] = useState([]);
      const [get_user_profile, set_Get_User_Profile] = useState({});
      console.log("get_user_profile", get_user_profile?.name)

      // <---------- User Authentciation token's ------------>
      const token = localStorage.getItem("token");
      const headers = {
            "Authorization": `Bearer ${token}`
      }

      const [formData, setFormData] = useState({
            name: "",
            email: "",
            website: "",
            message: "",
      });
      console.log("formData", formData?.name)
      // Handle input changes
      const handleChange = (e) => {
            setFormData({
                  ...formData,
                  [e.target.name]: e.target.value,
            });
      };

      useEffect(() => {
            const handle_get_user_profile = async () => {
                  try {
                        const response = await user_Profile(headers);
                        set_Get_User_Profile(response?.data?.user)
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_user_profile();
      }, [])

      useEffect(() => {
            if (get_user_profile) {
                  setFormData(prev => ({
                        ...prev,
                        name: get_user_profile?.name || '',
                        email: get_user_profile?.email || '',
                  }));
            }
      }, [get_user_profile]);

      // Handle form submission
      const handleSubmit = async (e) => {
            e.preventDefault();
            setLoading(true);
            setResponseMessage("");
            const payload = {
                  name: formData.name,
                  email: formData.email,
                  website: formData.website,
                  message: formData.message,
            };
            try {
                  const response = await fetch(`${API_BASE_URL}/contact-store`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                  });
                  const result = await response.json();
                  if (response.ok) {
                        setResponseMessage("Message sent successfully!");
                        setFormData({ name: "", email: "", website: "", message: "" }); // Clear form
                  } else {
                        setResponseMessage(result.message || "Something went wrong!");
                  }
            } catch (error) {
                  setResponseMessage("Network error. Please try again.");
            }
            setLoading(false);
      };

      // const submitContactData = (e) => {
      //       e.preventDefault()
      //       const formdata = new FormData();
      //       formdata.append("name", "Test By Sameer");
      //       formdata.append("email", "admin@gmail.com");
      //       formdata.append("website", "locknpay.com");
      //       formdata.append("question", "can i get your contact number");

      //       const requestOptions = {
      //             method: "POST",
      //             body: formdata,
      //             redirect: "follow"
      //       };

      //       fetch("http://122.160.154.127:8080/api/create-checkout-session", requestOptions)
      //             .then((response) => response.text())
      //             .then((result) => console.log(result))
      //             .catch((error) => console.error(error));
      // }

      // <----------- render the main banner section ---------->
      useEffect(() => {
            const handle_get_main_banner_section = async () => {
                  try {
                        const response = await get_main_banner_section();
                        set_Banner_List(response?.data?.data?.banners)
                  } catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_main_banner_section();
      }, [])

      return (
            <div>
                  <Header />
                  <PageMainBanner 
                  heading="Contact Support" 
                  title={get_banner_list?.contact_us_title} 
                  para={get_banner_list?.contact_us_description} 
                  image={get_banner_list?.contact_us_image ? `${IMG_BASE_URL}/${get_banner_list?.contact_us_image}` : "assets/images/contact-support.png"}  
                  tollFree="1 (800) 941-0125" 
                  />


                  <section className="relative py-10 md:py-24">
                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-transparent" />
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">

                              <div className="relative">
                                    <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/10 via-transparent to-blue-500/10 blur-3xl">
                                    </div>
                                    <div className="grid lg:grid-cols-1 gap-6">
                                          {/* <div className="relative backdrop-blur-xl bg-gray-50/50 rounded-xl p-8 h-full border border-gray-600/10 hover:border-blue-800/50 transition-colors">
                                                <div className="google_map">
                                                      <h2 className="text-2xl font-bold mb-8">Google Map</h2>
                                                      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d227748.4368273456!2d75.62540116817397!3d26.885420992062897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4adf4c57e281%3A0xce1c63a0cf22e09!2sJaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1739946643462!5m2!1sen!2sin" width="100%" className="rounded-lg" height={450} style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                                                </div>
                                          </div> */}
                                          <div className="relative backdrop-blur-xl bg-gray-50/50 rounded-xl p-8 h-full border border-gray-600/10 hover:border-blue-800/50 transition-colors">
                                                <h2 className="text-2xl font-bold mb-8">Send us a Message</h2>
                                                <form className="space-y-6" onSubmit={handleSubmit}>
                                                      <div className="grid lg:grid-cols-2 gap-6">
                                                            <div>
                                                                  <label className="block text-sm font-medium text-gray-400 mb-2">Name</label>
                                                                  <input
                                                                        type="text"
                                                                        name="name"
                                                                        value={formData.name}
                                                                        onChange={handleChange}
                                                                        className="w-full rounded-lg py-3 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100"
                                                                        required />
                                                            </div>
                                                            <div>
                                                                  <label className="block text-sm font-medium text-gray-400 mb-2">Email</label>
                                                                  <input
                                                                        type="email"
                                                                        name="email"
                                                                        value={formData.email}
                                                                        onChange={handleChange}
                                                                        className="w-full rounded-lg py-3 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100"
                                                                        required />
                                                            </div>
                                                      </div>
                                                      <div>
                                                            <label className="block text-sm font-medium text-gray-400 mb-2">Subject</label>
                                                            <input
                                                                  type="text"
                                                                  name="website"
                                                                  value={formData.website}
                                                                  onChange={handleChange}
                                                                  className="w-full rounded-lg py-3 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100" />
                                                      </div>
                                                      <div>
                                                            <label className="block text-sm font-medium text-gray-400 mb-2">Message</label>
                                                            <textarea
                                                                  rows={6}
                                                                  name="message"
                                                                  value={formData.message}
                                                                  onChange={handleChange}
                                                                  className="w-full rounded-lg py-3 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100"
                                                                  required
                                                            />
                                                      </div>
                                                      <div>
                                                            <button
                                                                  type="submit"
                                                                  disabled={loading}
                                                                  className="rounded-lg md:w-[200px] bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center"
                                                            >
                                                                  {loading ? "Sending..." : "Send Message"}
                                                            </button>
                                                      </div>
                                                </form>
                                                {responseMessage && (
                                                      <p className={`mt-4 text-sm ${responseMessage.includes("success") ? "text-green-600" : "text-red-600"}`}>
                                                            {responseMessage}
                                                      </p>
                                                )}
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section>

                  <Footer />

            </div>
      )
}

export default ContactUs